export default __webpack_public_path__ + "static/media/cutting-stones.56273834.md";